import { render } from "./CobiCountries.vue?vue&type=template&id=48630fb2&scoped=true"
import script from "./CobiCountries.vue?vue&type=script&lang=js"
export * from "./CobiCountries.vue?vue&type=script&lang=js"

import "./CobiCountries.vue?vue&type=style&index=0&id=48630fb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48630fb2"]])

export default __exports__